<template>
  <div class="layout">
    <div v-for="(option, key) in values" :key="key">
      <label class="switch-item">
        <input
          :name="switchName"
          type="radio"
          v-model="type"
          :value="option.value"
          :checked="key === 0"
          @click="e => onClick(e)"
        />
        <span class="checkmark">{{ option.label }}</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: ["name", "values", "onChange"],
  data: function() {
    let selected = 0;
    this.values.forEach((value, index) => {
      if(value.selected) selected = index;
    });
    return {
      state: 0,
      switchName: this.name || "switch",
      type: this.values[selected].value
    };
  },
  methods: {
    onClick: function(e) {
      this.type = e.target.value;

      this.$emit("tipo", this.type);
      if (this.onChange) {
        this.onChange(this.type);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  margin: 0 20px;
}
/* The switch-item */
.switch-item {
  cursor: pointer;
  padding: 0;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.switch-item input {
  opacity: 0;
  height: 0;
  width: 0;
  cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
  height: 100%;
  width: 100%;
  background-color: #ddd;
  padding: 16px;
  transition: all 100ms linear;
}

/* On mouse-over, add a grey background color */
.switch-item:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.switch-item input:checked ~ .checkmark {
  background-color: #333;
  color: white;
  font-weight: bold;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  position: absolute;
  display: none;
}
</style>
